<template>
  <div
    id="subscription-stats"
  >
    <h2>
      Subscription Stats
    </h2>
    <subscription-nav
      :v-if="showNav"
    />

    <p
      class="text-center"
      v-if="base.loading"
    >
      <spinner
        size="large"
      />
    </p>

    <div
      v-else
    >
      <p
        class="alert alert-primary text-center"
      >
        Subscriber numbers may differ from queued email counts
        due to permanently bounced emails, server complaints, or
        duplicate subscriptions.
      </p>

      <table
        class="table"
      >
        <th>
          Subscription Stat Type
        </th>
        <th>
          Count
        </th>
        <tr>
          <td>
            Active Subscribers
          </td>
          <td>
            {{ stats.active_subscribers }}
          </td>
        </tr>
        <tr>
          <td>
            Lapsed Subscribers
          </td>
          <td>
            {{ stats.lapsed_subscribers }}
          </td>
        </tr>
        <tr>
          <td>
            Lapsed Free Subscribers
          </td>
          <td>
            {{ stats.lapsed_free_subscribers }}
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>
<script>
import Spinner from 'vue-simple-spinner'
import SubscriptionNav from '@/components/SubscriptionNav'

import { mapState } from 'vuex'

export default {
  props: {
    showNav: {
      type: Boolean,
      default: true
    }
  },

  computed: mapState({
    base: state => state.base,
    stats: state => state.StatModule.subscribers
  }),

  components: {
    'spinner': Spinner,
    'subscription-nav': SubscriptionNav
  },

  created () {
    this.get()
  },

  methods: {
    get () {
      return this.$store.dispatch(
        `StatModule/getSubscriberStats`
      ).catch(this.$root.processErrors)
    }
  }
}
</script>
<style
  scoped
>
  table, th {
    border-top: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/SubscriptionStats.vue